// Date ranges for Analytics > Reports, on 'YYYY-MM-DD' strings (calendar
// dates; no time zone). "today" always comes from the server.

const parts = (s) => s.split('-').map(Number);
const iso = (d) => d.toISOString().slice(0, 10);

export const addDays = (s, n) => {
  const [y, m, d] = parts(s);
  return iso(new Date(Date.UTC(y, m - 1, d + n)));
};
// Month m of year y (m may run past 1–12; it rolls into the next/prior year).
export const monthStart = (y, m) => iso(new Date(Date.UTC(y, m - 1, 1)));
export const monthEnd = (y, m) => iso(new Date(Date.UTC(y, m, 0)));
const isMonthStart = (s) => s.slice(8) === '01';
const isMonthEnd = (s) => { const [y, m] = parts(s); return s === monthEnd(y, m); };

// From / to for a preset ('' = open-ended). Full months / quarters end with the
// last complete one before today.
export function presetRange(key, today) {
  if (!today) return { from: '', to: '' };
  const [y, m] = parts(today);
  const q = Math.floor((m - 1) / 3) * 3 + 1; // first month of this quarter
  switch (key) {
    case 'last12': return { from: monthStart(y, m - 12), to: monthEnd(y, m - 1) };
    case 'last4q': return { from: monthStart(y, q - 12), to: monthEnd(y, q - 1) };
    case 'ytd': return { from: `${y}-01-01`, to: today };
    case 'lastYear': return { from: `${y - 1}-01-01`, to: `${y - 1}-12-31` };
    default: return { from: '', to: '' };
  }
}

// Invoicing is a month behind, and payroll cost falls half in the month before
// the invoice and half in the invoice's month. With Invoiced shown:
// Actual Cost runs half a month earlier — from the 16th of the prior month
// when the range starts on the 1st (else 15 days earlier), to the 15th when it
// ends on a month's last day (else 15 days earlier).
export function costRange({ from, to }) {
  return {
    from: from && (isMonthStart(from) ? `${monthStart(parts(from)[0], parts(from)[1] - 1).slice(0, 8)}16` : addDays(from, -15)),
    to: to && (isMonthEnd(to) ? `${to.slice(0, 8)}15` : addDays(to, -15)),
  };
}

// Rate Sheet Cost runs one month earlier: whole months when the range starts
// on the 1st / ends on a month's last day, else 30 days earlier.
export function rateRange({ from, to }) {
  return {
    from: from && (isMonthStart(from) ? monthStart(parts(from)[0], parts(from)[1] - 1) : addDays(from, -30)),
    to: to && (isMonthEnd(to) ? monthEnd(parts(to)[0], parts(to)[1] - 1) : addDays(to, -30)),
  };
}
